module.exports = __webpack_public_path__ + "img/75fc41e.png";